import { getFavoriteIdFromFolderId } from "owa-favorites";
import { getFolderIdForSelectedNode } from "owa-mail-folder-forest-store";
import React from "react";

export default function useRetainedFavoriteId(isSideRailVisible: boolean): string | undefined {
    const retainedFavoriteIdRef = React.useRef<string | undefined>(isSideRailVisible ? getSelectedFavoriteId() : undefined);
    const wasSideRailVisibleRef = React.useRef(isSideRailVisible);
    const isBecomingVisible = isSideRailVisible && !wasSideRailVisibleRef.current;
    const retainedFavoriteId = !isSideRailVisible
        ? undefined
        : isBecomingVisible
            ? getSelectedFavoriteId()
            : retainedFavoriteIdRef.current;
    
    React.useEffect(() => {
        retainedFavoriteIdRef.current = isSideRailVisible ? retainedFavoriteId : undefined;
        wasSideRailVisibleRef.current = isSideRailVisible;
    }, [isSideRailVisible, retainedFavoriteId]);
    
    return retainedFavoriteId;
}

function getSelectedFavoriteId(): string | undefined {
    const selectedFolderId = getFolderIdForSelectedNode();
    return selectedFolderId ? getFavoriteIdFromFolderId(selectedFolderId) : undefined;
}
